export const UPLOAD_MANUAL = "UPLOAD_MANUAL";
export const GET_MANUALS = "GET_MANUALS";
